// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosError, AxiosResponse } from 'axios';
import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { getLabInformation } from '../../apis/lab';
import { LabInformation } from '../../types/Model';
import { getLabInformationActions } from '../actionCreators/getLabInformationActions';
import { RootAction } from '../rootActionCreator';
import { RootState } from '../rootReducer';

const outputActions = {
  success: getLabInformationActions.success,
  failure: getLabInformationActions.failure
};

type RequestActionTypes = ActionType<typeof getLabInformationActions.request>;
type OutputActionTypes = ActionType<typeof outputActions>;

export const getLabInformationEpic = (
  action$: Observable<RootAction>,
  _state$?: Observable<RootState>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      // action filter
      getType(getLabInformationActions.request)
    ),
    switchMap((action: RequestActionTypes) => {
      // prepare api params
      const { id, condition, workshopId, iltCourseId } = action.payload;
      // send api promise
      return getLabInformation(id, condition, workshopId, iltCourseId)
        .then((response: AxiosResponse<LabInformation>) => {
          // handle success case here
          return getLabInformationActions.success({
            labInformation: response.data
          });
        })
        .catch((error: AxiosError) => {
          // handle error case here
          switch (error.response?.status) {
            case 401:
              return getLabInformationActions.failure({
                error: error.response?.request.response
              });
            case 404:
              return getLabInformationActions.failure({
                error: error.response?.request.response
              });
            case 403:
              return getLabInformationActions.failure({
                error: new Error('本實驗目前無法提供使用，請選擇其他實驗。')
              });
            default:
              return getLabInformationActions.failure({
                error: new Error('系統出現暫時性的錯誤，請點擊再次嘗試。')
              });
          }
        });
    })
  );
};
